import { clsx, type ClassValue } from 'clsx'

export function cn(...inputs: ClassValue[]) {
  return clsx(inputs)
}

export function formatDate(dateString: string, locale: string = 'ko-KR'): string {
  const date = new Date(dateString)
  return date.toLocaleDateString(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })
}

export function formatDateTime(dateString: string, locale: string = 'ko-KR'): string {
  const date = new Date(dateString)
  return date.toLocaleString(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function formatNumber(num: number, locale: string = 'ko-KR'): string {
  return num.toLocaleString(locale)
}

export function formatCurrency(amount: number, locale: string = 'ko-KR'): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'KRW',
    maximumFractionDigits: 0,
  }).format(amount)
}

export function formatPhone(phone: string): string {
  const cleaned = phone.replace(/\D/g, '')
  if (cleaned.length === 11) {
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7)}`
  }
  if (cleaned.length === 10) {
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`
  }
  return phone
}

export function normalizePhone(phone: string): string {
  return phone.replace(/\D/g, '')
}

export function getDaysUntilExpiry(expiresAt: string): number {
  const now = new Date()
  const expiry = new Date(expiresAt)
  const diff = expiry.getTime() - now.getTime()
  return Math.ceil(diff / (1000 * 60 * 60 * 24))
}

export function getExpiryStatus(daysUntilExpiry: number): 'expired' | 'expiring-soon' | 'ok' {
  if (daysUntilExpiry <= 0) return 'expired'
  if (daysUntilExpiry <= 7) return 'expiring-soon'
  return 'ok'
}

export function getStatusColor(status: string): string {
  switch (status) {
    case 'completed':
    case 'sent':
    case 'delivered':
      return 'text-success'
    case 'pending':
      return 'text-warning'
    case 'failed':
    case 'cancelled':
      return 'text-danger'
    default:
      return 'text-light-text-muted dark:text-dark-text-muted'
  }
}
